<div class="table-responsive rounded" *ngIf="field.options?.hideIfNoValue === true ? ((rows && rows.length > 0) ? true: false) : true">
    <table class="table rounded cv-table">
        <thead *ngIf="field.options?.header !== false">
            <tr class="d-flex">
                <ng-container *ngFor="let column of field.options.columns">
                    <th *ngIf="column?.type !== 'table'"
                        [ngClass]="column?.cssClass"
                        [attr.colspan]="column?.colSpan">
                        {{column.options.header || ''}}
                    </th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let row of rows; let i = index;">
                <tr class="d-flex">
                    <ng-container *ngFor="let col of field.options.columns">
                        <td *ngIf="col?.type !== 'table'"
                            [attr.colspan]="col?.colSpan" 
                            [ngClass]="col?.cssClass">

                            <h6 *ngIf="col.options?.label">
                                {{col.options.label}}
                            </h6>
                            <span *ngIf="col.options.path" 
                                [ngClass]="col.options?.cssClass">

                                <cv-in-review-fields
                                    class="cv_col"
                                    #fields
                                    [targets]="selectedTargets"
                                    [highlight]="selectedType"
                                    [options]="col.options | inReviewTableColumnOptions:i:base">
                                </cv-in-review-fields>
                            </span>
                        </td>
                    </ng-container>
                </tr>
                <ng-container *ngFor="let col of field.options.columns">                    
                    <tr class="d-flex" *ngIf="col?.type === 'table' && row[col.options.path] && row[col.options.path].length">
                        <td class="col-sm-12 nested">
                            <h5>{{col.options.header || ''}}</h5>
                            <cv-in-review-tables
                                #tables
                                [nested]="true"
                                [field]="col | inReviewNestedTableOptions:i:base"
                                [selectedType]="selectedType"
                                [selectedTargets]="selectedTargets"
                                >
                            </cv-in-review-tables>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="!rows">
                <tr>
                   <td class="text-center" [attr.colspan]="(field.options.columns | inOnlyRealColumns).length - 1">
                        Not Available
                   </td> 
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>